/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';

import { Individu, ListeRecensement } from '@/types';

const validationInformationsContact = (data: Partial<Individu>, valideMail: boolean = true, valideTel: boolean = true) => {
  const errors = {
    tel1: '',
    mail: '',
  };

  if(data.recensement === ListeRecensement.NonRecenses) {
    return null;
  }

  if ((_.isNil(data?.tel1) || _.isEmpty(data?.tel1)) && valideTel) {
    errors.tel1 = 'Le numéro de téléphone 1 est obligatoire';	
  }

  if(!(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(data?.mail)) && valideMail) {
    errors.mail = 'Le mail est invalide';
  }

  if ((_.isNil(data?.mail) || _.isEmpty(data?.mail)) && valideMail) {
    errors.mail = 'Le mail est obligatoire';	
  }

  return _.pickBy(errors, (value) => value !== '');
};

export default validationInformationsContact;
